import { useContext, useEffect, useState } from 'react'
import { getRequest, putRequest } from '../../../../services/base'
import { useNavigate, useParams } from 'react-router-dom'
import { NavContext } from '../../../../context/global_context'
import TextArea from '../../../common/TextArea'
import DtcsHeader from '../DtcsHeader'
import { Card, Flex, Form, Row, Space, Typography } from 'antd'
import Button from '../../../common/Button'
import InlineCheckbox from '../../../common/InlineCheckbox'
import { useIntl } from 'react-intl'

const DtcEditComponent = () => {
  const [value, dispatch] = useContext(NavContext)
  let { dtc_id, vehicle } = useParams()
  const navigate = useNavigate()
  const intl = useIntl()
  const [payload, setPayload] = useState({
    create_dtc_circuits: false,
    clone_with_existing_mapping: false,
    target_dtcs: [],
    active: false,
    destination_only: false,
    short_description: '',
    description: '',
    description_2: '',
    ecu: '',
    name: '',
  })
  const [form] = Form.useForm()

  const saveDtcs = async (msg) => {
    dispatch({
      type: 'loader',
      data: {
        caption: intl.formatMessage({ id: 'dtcs.edit.saving' }),
        showLoader: true,
      },
      notification: {},
    })
    let res = await putRequest(`/api/dtcs/update_dtcs/${dtc_id}/`, payload)
    dispatch({
      type: 'notification',
      data: {
        notification_type: 'success',
        msg: intl.formatMessage({ id: 'dtcs.edit.saveSuccess' }, { name: value?.dtc_details[0].name }),
      },
    })
    navigate(`/vehicles/${vehicle}/dtcs/listing`)
  }

  useEffect(() => {
    getDtcsList()
  }, [])

  const getDtcsList = async () => {
    dispatch({
      type: 'loader',
      data: {
        caption: intl.formatMessage({ id: 'dtcs.edit.fetchingData' }),
        showLoader: true,
      },
      notification: {},
    })

    let dtcs_res = await getRequest(`/api/dtcs/${dtc_id}/?vehicle=${vehicle}`)

    setPayload({
      ...payload,
      active: dtcs_res.active,
      destination_only: dtcs_res.destination_only,
      description_2: dtcs_res.description_2,
      description: dtcs_res.description,
      short_description: dtcs_res.short_description,
      ecu: dtcs_res.ecu,
      name: dtcs_res.name,
    })

    dispatch({
      type: 'header',
      data: {
        header: intl.formatMessage({ id: 'layout.adminTools' }),
        sub_header: `Vehicle List / ${vehicle} / DTCs / Tracer Authoring Mappings / DTC Edit`,
        id: '',
        show_back_btn: true,
        dtc_details: [dtcs_res],
        vehicle: vehicle,
        back_btn_url: `/vehicles/${vehicle}/dtcs/listing`,
      },
    })
  }
  const getInitialValues = () => {
    return {
      short_description: payload?.short_description,
      description: payload?.description,
      description_2: payload?.description_2,
      destination_only: payload?.destination_only,
      active: payload?.active,
    }
  }
  useEffect(() => {
    form.setFieldsValue(getInitialValues())
  }, [payload])

  return (
    <div className="page dtc-edit">
      <Row className="title">
        <Flex vertical gap={16} style={{width: '100%'}}>
          {value?.dtc_details?.length > 0 && (
            <DtcsHeader dtcs={value?.dtc_details} vehicleSid={value?.vehicle} />
          )}

          <Typography.Title level={5}>
            {intl.formatMessage({ id: 'dtcs.edit.title'}, {ecu: payload.ecu, name: payload.name })}
          </Typography.Title>
        </Flex>
      </Row>
      <Row className="body">
        <Form
          id="dtc-edit-form"
          name="dtc-edit-form"
          className='dtc-edit-form'
          form={form}
          layout="vertical"
          onFinish={() => saveDtcs('Saved')}
        >
          <Card title="" variant="outlined">
            <Flex gap={16} vertical>
              <Flex gap={16}>
                <TextArea
                  name="short_description"
                  label={intl.formatMessage({ id: 'dtcs.edit.shortDescription' })}
                  value={payload.short_description}
                  isRequired={false}
                  maxLength={128}
                  wrapperClass='dtc-edit-text-area'
                  onChange={(value) => {
                    setPayload({ ...payload, short_description: value })
                  }}
                />
              
                <TextArea
                  name="description"
                  value={payload.description}
                  label={intl.formatMessage({ id: 'dtcs.edit.description' })}
                  isRequired={false}
                  maxLength={128}
                  wrapperClass='dtc-edit-text-area'
                  onChange={(value) => {
                    setPayload({ ...payload, description: value })
                  }}
                />

                <TextArea
                  name="description_2"
                  value={payload.description_2}
                  label={intl.formatMessage({ id: 'dtcs.edit.description2' })}
                  isRequired={false}
                  wrapperClass='dtc-edit-text-area'
                  onChange={(value) => {
                    setPayload({ ...payload, description_2: value })
                  }}
                />
              </Flex>

              <InlineCheckbox
                name="destination_only"
                label={intl.formatMessage({ id: 'dtcs.edit.destinationOnly' })}
                value={payload?.destination_only}
                wrapperClass="justify-items-evenly"
                onChange={(value) => {
                  setPayload({ ...payload, destination_only: value })
                }}
              />

              <InlineCheckbox
                name="active"
                label={intl.formatMessage({ id: 'dtcs.edit.active' })}
                value={payload?.active}
                wrapperClass="justify-items-evenly"
                onChange={(value) => {
                  setPayload({ ...payload, active: value })
                }}
              />
            </Flex>
          </Card>
          <Space size='middle'>
            <Button htmlType="submit" type="primary" className="submit-button" testId="dtc-save">
              {intl.formatMessage({ id: 'dtcs.edit.saveDtc' })}
            </Button>
            <Button
              className="cancel-button"
              onClick={(e) => navigate(`/vehicles/${vehicle}/dtcs/listing`)}
            >
              {intl.formatMessage({ id: 'forms.cancel' })}
            </Button>
          </Space>
        </Form>
      </Row>
    </div>
  )
}

export default DtcEditComponent
